import shave from 'shave';
import { $win, getCurrentDevice } from './utils';

/**
 * Shave
 * How to use?
 *
 * Default version:
 * <div data-shave>Lorem ipsum</div>
 *
 * Number of line
 * <div data-shave="3">Lorem ipsum</div>
 */

const getMaxHeight = el => {
	const lines = el.getAttribute('data-shave') || 3;

	return lines * parseFloat($(el).css('line-height')) || 72;
}

export default function shaveUI() {
	document.querySelectorAll('[data-shave]').forEach(el => {
		const maxHeight = getMaxHeight(el);

		shave(el, maxHeight);

		if (el.hasAttribute('equalize')) el.style.height = `${maxHeight}px`;
	});
}
